import { render, staticRenderFns } from "./CounterControl.vue?vue&type=template&id=541212da&scoped=true&lang=pug&"
import script from "./CounterControl.vue?vue&type=script&lang=js&"
export * from "./CounterControl.vue?vue&type=script&lang=js&"
import style0 from "./CounterControl.vue?vue&type=style&index=0&id=541212da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541212da",
  null
  
)

component.options.__file = "CounterControl.vue"
export default component.exports